<template>
    <!-- Shared "sensor-gated KPI cell" pattern for the Active groups table (Vægt/Tilvækst/
         Vækstindeks columns): a "no sensor" icon when the section has no sensor of the relevant
         type, otherwise a button that opens the metric's detail modal - showing either the value
         (default slot) or a "no data" icon. The button stays clickable even with no data, so the
         detail modal can explain why (e.g. no active Production Group yet). -->
    <span v-if="!hasSensor" class="block px-3 py-[9px]" :title="$t('views.monitoring.activeGroups.texts.noSensor')">
        <Ban class="h-3.5 w-3.5 text-gray-300" aria-hidden="true" />
    </span>
    <button v-else type="button" class="w-full rounded-md px-3 py-[9px] transition-colors hover:bg-gray-200" :class="buttonClass" :title="openTitle" @click="emit('open')">
        <template v-if="hasValue">
            <slot />
        </template>
        <span v-else :title="$t('views.monitoring.activeGroups.texts.noData')">
            <WifiOff class="h-3.5 w-3.5 shrink-0 text-gray-300" aria-hidden="true" />
        </span>
    </button>
</template>

<script setup lang="ts">
import { Ban, WifiOff } from 'lucide-vue-next';

defineProps<{
    // False when the section has no sensor of the relevant type — the metric will never
    // populate, so a "no sensor" icon replaces the button entirely (nothing to open).
    hasSensor: boolean;
    // False when a sensor is present but no usable reading is available yet.
    hasValue: boolean;
    // The button's title/tooltip (opens the metric's own detail modal).
    openTitle: string;
    // The button's layout classes - callers differ slightly (items-baseline vs items-center, gap).
    buttonClass: string;
}>();

const emit = defineEmits<{
    open: [];
}>();
</script>
